"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushToDataLayer = void 0;
function pushToDataLayer(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}
exports.pushToDataLayer = pushToDataLayer;
